// removed by extract-text-webpack-plugin
module.exports = {"container":"style__container___3CFoY","containerWithoutTitle":"style__containerWithoutTitle___3CT9e","title":"style__title___1pgT9","titleBrand":"style__titleBrand___u6WwW","titleWhite":"style__titleWhite___1I2Q2","touchableClose":"style__touchableClose___2vnxk","closeIcon":"style__closeIcon___3HoBZ","humburger":"style__humburger___1Sd8F","headerBackBtn":"style__headerBackBtn___2vo9F"};


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/stickers/ui/components/scanner-header/style.css
// module id = 1094
// module chunks = 0